<template>
<div>
  <h4 class="m-b-30">
    Upsell logs
  </h4>

  
  <section class="log-container" v-if="logs.length > 0">
    <b-row>
    <b-col cols="6">
      <p class="m-t-10">Total count: {{ data.count }}</p>
    </b-col>
    <b-col cols="6">
      <b-pagination class="float-right" :total-rows="data.count" v-model="data.page" :per-page="data.pageSize" @input="fetchLogs">
      </b-pagination>
    </b-col>
  </b-row>
    <single-upsell-log v-for="log in logs" :key="log.id" :log="log" />

    <b-row>
    <b-col cols="6">
      <p class="m-t-10">Total count: {{ data.count }}</p>
    </b-col>
    <b-col cols="6">
      <b-pagination class="float-right" :total-rows="data.count" v-model="data.page" :per-page="data.pageSize" >
      </b-pagination>
    </b-col>
  </b-row>
  
  </section>
  <section v-else>
      <b-alert show variant="info">No Logs found for the selected store.</b-alert>
  </section>

  
</div>
</template>

<script>
const SingleUpsellLog = () => import( /* webpackChunkName: "single-upsell-log" */ "./single-upsell-log");
import UpsellAutomationService from '../../../services/upsell-automation.service';

export default {
  data() {
    return {
      logs: [],
      data: {
        shopifyStoreId: null,
        page: 1,
        pageSize: 25,
        count: 0,
      }
    }
  },
  components: {
    SingleUpsellLog
  },
  mounted() {
    this.data.shopifyStoreId = this.storeInState.id;
    this.fetchLogs()
  },
  methods: {
    async fetchLogs() {
      try {

        const result = await UpsellAutomationService.fetchUpsellLogs(this.data);
        this.logs = result.data.upsellLogs.rows;
        this.data.count = result.data.upsellLogs.count;
      } catch (errors) {
        console.log('Upsell logs error', errors)
      }
    }
  },
  watch: {
    storeInState(newValue, oldValue) {
      this.data.shopifyStoreId = this.storeInState.id;
      this.fetchLogs()
    }
  },
  computed: {
    storeInState() {
      return this.$store.state.ecommerceStore.store
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
